import React, { useRef } from "react";
import { motion } from "framer-motion";
// import NavigateNextOutlinedIcon from "@mui/icons-material/NavigateNextOutlined";
// import { useNavigate } from "react-router-dom";

import chatnexo from "../assets/Untitled design (10).png";
import diehard from "../assets/Die Hard.png";
import spotify from "../assets/Spotify.png";
import portfolio from "../assets/Profolio.png";
import one from "../assets/jap/1.png";
import two from "../assets/jap/2.png";
import three from "../assets/jap/3.png";
import four from "../assets/jap/4.png";
import five from "../assets/jap/5.png";
import intripid from "../assets/intripid (1).png";
import eschoolapp from "../assets/eschool.png";
import notificationAdmin from "../assets/notification.png";
// import sellwase from "../assets/selwase (1).png";
import football from "../assets/football.png";
import { RiExternalLinkLine } from "react-icons/ri";
import { Collapse } from "antd";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
const featuredProject = {
  title: "Jap Counter - Offline",

  logo: "https://lh3.googleusercontent.com/dw658e3Qe92H_vWB1bfZsC3uVc2Bdnash9bLgT__Jhx8rfR6whW4F3EEwYFHOaeDxf7XhW471A95CzNGnvwj",

  description:
    "Offline-first chanting tracker published on Google Play with Firebase Cloud Messaging, Cloudflare Workers and beautiful React Native UI.",

  playStore:
    "https://play.google.com/store/apps/details?id=com.pushkarchaubey10.chantingapp",

  youtube: "https://youtu.be/KQs-jfmvhRQ?si=UdYDjfvWqxmKa3f4",

  thumbnail: "https://i.ibb.co/ccvKf6dw/No-Internet-Required.png",

  screenshots: [one, two, three, four, five],

  features: [
    "Offline First",
    "FCM Notifications",
    "Cloudflare Remote Config",
    "Google AdMob",
    "Dark Theme",
    "Modern UI",
  ],

  stats: {
    platform: "Android",
    language: "React Native",
    backend: "Firebase",
    released: "2026",
  },

  tech: ["React Native", "Expo", "Firebase", "Cloudflare", "TypeScript", "FCM"],
};
const projects = [
  {
    id: "SchoolERP",
    title: "ESchool SaaS",
    description: "School Management SaaS Platform",
    image: eschoolapp,
    figma: eschoolapp,
    status: "Production",
    playsoreLink:
      "https://play.google.com/store/apps/details?id=com.blinkworx.eschoolapp&hl=en_IN",
    link: "#",
    techused: [
      "React",
      "Redux Toolkit",
      "Material UI",
      "Node.js",
      "MongoDB",
      "REST API",
    ],
    challenges: [
      "Built reusable dashboard modules for multiple schools.",
      "Managed complex CRUD operations and role-based access.",
      "Optimized rendering for large datasets.",
    ],
    learnings: [
      "Worked on a SaaS architecture used by multiple schools.",
      "Improved state management using Intenstive Redux Toolkit.",
      "Built scalable enterprise-level frontend modules.",
    ],
  },

  {
    id: "NotificationAdmin",
    title: "Jap Counter Admin",
    description: "Notification & Update Management Dashboard",
    image: notificationAdmin, // import image
    figma: notificationAdmin,
    status: "Production",
    link: "#",
    techused: [
      "Next.js",
      "Firebase",
      "Cloudflare Workers",
      "FCM",
      "Shadcn UI",
      "TypeScript",
    ],
    challenges: [
      "Built an admin panel to send push notifications to all users.",
      "Implemented remote app updates using Cloudflare Workers.",
      "Integrated Firebase Cloud Messaging with token management.",
    ],
    learnings: [
      "Serverless development using Cloudflare Workers.",
      "Firebase Admin SDK and FCM integration.",
      "Built production-ready admin dashboards using Next.js.",
    ],
  },

  {
    id: "Chatnexo",
    title: "Chatnexo",
    description: "WhatsApp CRM & Web Extension Platform",
    image: chatnexo,
    figma: chatnexo,
    status: "Production",
    link: "https://chatnexo.com/",
    techused: [
      "React",
      "Tailwind CSS",
      "Node.js",
      "MongoDB",
      "REST API",
      "Payments",
      "Figma",
    ],
    challenges: [
      "Built reusable CRM components for customer management.",
      "Integrated secure payment gateway workflows.",
      "Optimized API calls and application performance.",
    ],
    learnings: [
      "Developed scalable React architecture for large applications.",
      "Integrated backend REST APIs with reusable hooks.",
      "Worked in a production environment with real users.",
    ],
  },

  {
    id: "Intripid",
    title: "Intripid",
    description: "Travel Advisor Landing Platform",
    image: intripid,
    figma: intripid,
    status: "Production",
    link: "https://dev.intripid.co/",
    techused: [
      "React",
      "Tailwind CSS",
      "Shadcn UI",
      "Framer Motion",
      "REST API",
    ],
    challenges: [
      "Built the complete landing experience from scratch.",
      "Implemented responsive layouts across all screen sizes.",
      "Integrated multiple modern UI libraries while maintaining design consistency.",
    ],
    learnings: [
      "Improved reusable component architecture.",
      "Worked extensively with Shadcn UI and animation libraries.",
      "Learned modern frontend design systems.",
    ],
  },

  {
    id: "Diehard",
    title: "Die Hard",
    description: "Movie Review Platform",
    image: diehard,
    figma: diehard,
    status: "Live",
    link: "https://inspiring-clafoutis-bdc7fd.netlify.app/",
    techused: ["React", "Tailwind CSS", "REST API", "Figma"],
    challenges: [
      "Integrated movie data from external APIs.",
      "Created reusable movie cards and search experience.",
      "Maintained responsive UI for desktop and mobile.",
    ],
    learnings: [
      "REST API integration.",
      "Component reusability.",
      "Performance optimization.",
    ],
  },

  {
    id: "Portfolio",
    title: "Developer Portfolio",
    description: "Modern Developer Portfolio",
    image: portfolio,
    figma: portfolio,
    status: "Live",
    link: "#",
    techused: ["React", "Tailwind CSS", "Framer Motion"],
    challenges: [
      "Designed a modern glassmorphism UI.",
      "Implemented smooth animations across sections.",
      "Optimized responsive layouts.",
    ],
    learnings: [
      "Advanced Framer Motion animations.",
      "Modern UI/UX principles.",
      "Performance optimization.",
    ],
  },

  {
    id: "SpotifyClone",
    title: "Spotify Clone",
    description: "Music Streaming Application",
    image: spotify,
    figma: spotify,
    status: "Live",
    link: "https://spotifyp1000.netlify.app/",
    techused: ["React", "Spotify API", "Node.js", "CSS"],
    challenges: [
      "Integrated Spotify Web API.",
      "Fetched albums, playlists and songs dynamically.",
      "Implemented audio playback and music controls.",
    ],
    learnings: [
      "Working with OAuth-based APIs.",
      "Handling asynchronous media data.",
      "Building interactive music players.",
    ],
  },

  {
    id: "FootballHighlights",
    title: "Football Highlights",
    description: "Football Highlights Platform",
    image: football,
    figma: football,
    status: "Live",
    link: "https://footballhilights.netlify.app/",
    techused: ["React", "Scorebat API", "CSS"],
    challenges: [
      "Integrated the Scorebat API to fetch match highlights.",
      "Displayed video highlights dynamically.",
      "Built responsive layouts for sports content.",
    ],
    learnings: [
      "Working with third-party sports APIs.",
      "Video embedding and rendering.",
      "Optimizing API requests.",
    ],
  },
];

const Projects = () => {
  // const navigate = useNavigate();

  // const { Panel } = Collapse;

  const screenshotsRef = useRef(null);

  const scrollLeft = () => {
    screenshotsRef.current?.scrollBy({
      left: -280,
      behavior: "smooth",
    });
  };

  const scrollRight = () => {
    screenshotsRef.current?.scrollBy({
      left: 280,
      behavior: "smooth",
    });
  };

  return (
    <section className="relative overflow-hidden bg-custombg py-24 px-6">
      {/* <div className="absolute -top-40 left-0 h-96 w-96 rounded-full bg-yellow-500/20 blur-[120px]" /> */}
      {/* <div className="absolute bottom-0 right-0 h-96 w-96 rounded-full bg-purple-500/20 blur-[120px]" /> */}

      <div className="absolute inset-0 overflow-hidden">
        {/* Purple */}
        <div className="absolute top-[-10%] left-[-10%] h-[500px] w-[500px] rounded-full bg-purple-500/30 blur-[120px] animate-[float_12s_ease-in-out_infinite]" />

        {/* Blue */}
        <div className="absolute bottom-[-20%] right-[-10%] h-[500px] w-[500px] rounded-full bg-blue-500/30 blur-[120px] animate-[float2_15s_ease-in-out_infinite]" />

        {/* Pink */}
        <div className="absolute top-[40%] left-[40%] h-[350px] w-[350px] rounded-full bg-pink-500/20 blur-[100px] animate-[pulse_10s_linear_infinite]" />

        {/* Cyan */}
        <div className="absolute top-[20%] right-[20%] h-[250px] w-[250px] rounded-full bg-cyan-400/20 blur-[100px]" />
      </div>

      {/* Grid Overlay */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.04)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.04)_1px,transparent_1px)] bg-[size:40px_40px]" />

      {/* Noise Texture */}
      <div className="absolute inset-0 opacity-[0.03] bg-[url('https://grainy-gradients.vercel.app/noise.svg')]" />

      {/* Glow Ring */}
      <div className="absolute h-[600px] w-[600px] rounded-full border border-white/10 blur-3xl" />

      <div className="relative mx-auto max-w-7xl">
        <div className="text-center mb-16">
          <p className="text-yellow-400 font-medium uppercase tracking-[0.3em]">
            Selected Work
          </p>

          <h2 className="mt-4 text-5xl font-bold text-white">
            Projects I've Built
          </h2>

          <p className="mt-5 text-gray-400 max-w-2xl mx-auto">
            Production-ready web and mobile applications built using React,
            Next.js and React Native.
          </p>
        </div>

        <motion.div
          whileHover={{ y: -4 }}
          className="rounded-3xl border border-white/10 bg-white/5 backdrop-blur-xl overflow-hidden p-8"
        >
          <div className="grid lg:grid-cols-[1.4fr_.9fr] gap-10">
            {/* Left */}
            <div>
              <span className="rounded-full bg-green-500/20 text-green-300 px-4 py-2 text-sm">
                🚀 Featured • Google Play
              </span>

              <div className="flex items-center gap-5 mt-6">
                <img
                  src={featuredProject.logo}
                  alt=""
                  className="h-24 w-24 rounded-3xl shadow-xl"
                />

                <div>
                  <h2 className="text-4xl font-bold text-white">
                    {featuredProject.title}
                  </h2>

                  <p className="text-gray-400 mt-2">Published on Google Play</p>
                </div>
              </div>

              <p className="mt-6 text-gray-300 leading-8">
                {featuredProject.description}
              </p>

              {/* Tech */}

              <div className="flex flex-wrap gap-3 mt-8">
                {featuredProject.tech.map((tech) => (
                  <span
                    key={tech}
                    className="rounded-full border border-yellow-400/20 bg-yellow-400/10 px-4 py-2 text-sm text-yellow-300"
                  >
                    {tech}
                  </span>
                ))}
              </div>

              {/* Features */}

              <div className="grid grid-cols-2 gap-3 mt-10">
                {featuredProject.features.map((item) => (
                  <div
                    key={item}
                    className="flex items-center gap-2 text-gray-300"
                  >
                    <span className="h-2 w-2 rounded-full bg-green-400" />
                    {item}
                  </div>
                ))}
              </div>

              {/* Buttons */}

              <div className="flex flex-wrap gap-4 mt-10">
                <a
                  href={featuredProject.playStore}
                  target="_blank"
                  rel="noreferrer"
                  className="group inline-flex items-center gap-3 rounded-2xl bg-gradient-to-r from-green-500 to-emerald-600 px-6 py-3 text-white font-semibold shadow-lg shadow-green-500/20 transition-all duration-300 hover:-translate-y-1 hover:shadow-green-500/40"
                >
                  <img
                    src="https://static.vecteezy.com/system/resources/previews/017/395/379/non_2x/google-play-store-mobile-apps-logo-free-png.png"
                    alt="Google Play"
                    className="h-6 w-6 rounded-md"
                  />

                  <div className="flex flex-col items-start leading-none">
                    <span className="text-[10px] uppercase tracking-wider opacity-80">
                      Available on
                    </span>
                    <span className="text-sm font-bold">Google Play</span>
                  </div>

                  <RiExternalLinkLine
                    size={18}
                    className="ml-1 transition-transform duration-300 group-hover:translate-x-1"
                  />
                </a>

                <a
                  href={featuredProject.youtube}
                  target="_blank"
                  rel="noreferrer"
                  className="rounded-xl border border-white/20 px-6 py-3 text-white flex items-center gap-2"
                >
                  ▶ Watch Demo
                </a>
              </div>
            </div>

            {/* Right */}

            <div className="space-y-6">
              {/* Screenshots */}

              <div>
                <h3 className="text-white font-semibold mb-4">App Screens</h3>

                <div className="relative group">
                  {/* Left Button */}
                  <button
                    onClick={scrollLeft}
                    className="absolute left-3 top-1/2 z-20 -translate-y-1/2 h-11 w-11 rounded-full
      bg-black/60 backdrop-blur-md border border-white/10
      flex items-center justify-center text-white
      opacity-0 group-hover:opacity-100
      transition duration-300 hover:bg-yellow-400 hover:text-black"
                  >
                    <ChevronLeft size={20} />
                  </button>

                  {/* Right Button */}
                  <button
                    onClick={scrollRight}
                    className="absolute right-3 top-1/2 z-20 -translate-y-1/2 h-11 w-11 rounded-full
      bg-black/60 backdrop-blur-md border border-white/10
      flex items-center justify-center text-white
      opacity-0 group-hover:opacity-100
      transition duration-300 hover:bg-yellow-400 hover:text-black"
                  >
                    <ChevronRight size={20} />
                  </button>

                  {/* Screenshots */}
                  <div
                    ref={screenshotsRef}
                    className="flex gap-4 overflow-x-auto hide-scrollbar scroll-smooth"
                  >
                    {featuredProject.screenshots.map((img, index) => (
                      <img
                        key={index}
                        src={img}
                        alt=""
                        className="h-72 rounded-2xl border border-white/10 flex-shrink-0 transition duration-300 hover:scale-105"
                      />
                    ))}
                  </div>
                </div>
              </div>

              {/* Demo */}

              <a
                href={featuredProject.youtube}
                target="_blank"
                rel="noreferrer"
                className="group relative block overflow-hidden rounded-3xl"
              >
                <img
                  src={featuredProject.thumbnail}
                  className="w-full rounded-3xl transition duration-500 group-hover:scale-105"
                  alt="Thumbnail"
                />

                <div className="absolute inset-0 bg-black/40" />

                <div className="absolute inset-0 flex justify-center items-center">
                  <div className="h-20 w-20 rounded-full bg-red-600 flex justify-center items-center shadow-2xl">
                    <span className="text-white text-3xl ml-1">▶</span>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </motion.div>

        {/* Add your existing project grid below */}

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8">
          {projects.map((project, index) => (
            <motion.div
              key={project.title}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              whileHover={{ y: -8 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.08 }}
              className="group overflow-hidden rounded-3xl border border-white/10 bg-white/5 backdrop-blur-xl"
            >
              {/* Image */}
              <div className="relative h-56 overflow-hidden">
                <img
                  src={project.image}
                  alt={project.title}
                  className="h-full w-full object-cover transition duration-700 group-hover:scale-110"
                />

                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent" />

                <div className="absolute top-4 left-4">
                  <span className="rounded-full bg-green-500/20 px-3 py-1 text-xs font-medium text-green-300 backdrop-blur">
                    Live Project
                  </span>
                </div>

                {/* <a
                  href={project.link}
                  target="_blank"
                  rel="noreferrer"
                  className="absolute top-4 right-4 flex h-11 w-11 items-center justify-center rounded-xl bg-black/40 text-white backdrop-blur transition hover:bg-yellow-400 hover:text-black"
                >
                  <RiExternalLinkFill size={18} />
                </a> */}
              </div>

              {/* Content */}
              <div className="p-6">
                <div className="flex justify-between items-center">
                  <h3 className="text-2xl font-bold text-white">
                    {project.title}
                  </h3>
                  {project.playsoreLink && (
                    <a
                      href={project.playsoreLink}
                      target="_blank"
                      rel="noreferrer"
                      className="group inline-flex items-center gap-3 rounded-2xl bg-gradient-to-r from-green-500 to-emerald-600 px-6 py-3 text-white font-semibold shadow-lg shadow-green-500/20 transition-all duration-300 hover:-translate-y-1 hover:shadow-green-500/40"
                    >
                      <img
                        src="https://static.vecteezy.com/system/resources/previews/017/395/379/non_2x/google-play-store-mobile-apps-logo-free-png.png"
                        alt="Google Play"
                        className="h-6 w-6 rounded-md"
                      />

                      <div className="flex flex-col items-start leading-none">
                        <span className="text-[10px] uppercase tracking-wider opacity-80">
                          Available on
                        </span>
                        <span className="text-sm font-bold">Google Play</span>
                      </div>

                      <RiExternalLinkLine
                        size={18}
                        className="ml-1 transition-transform duration-300 group-hover:translate-x-1"
                      />
                    </a>
                  )}
                </div>

                <p className="mt-3 text-gray-400 leading-7">
                  {project.description}
                </p>

                {/* Tech Stack */}
                <div className="mt-6 flex flex-wrap gap-2">
                  {project.techused.map((tech) => (
                    <span
                      key={tech}
                      className="rounded-full border border-yellow-400/20 bg-yellow-400/10 px-3 py-1 text-xs text-yellow-300"
                    >
                      {tech}
                    </span>
                  ))}
                </div>

                <div className="mt-6">
                  <Collapse
                    ghost
                    expandIconPosition="end"
                    className="project-collapse"
                    items={[
                      {
                        key: "1",
                        label: (
                          <span className="text-yellow-400 font-medium">
                            View Project Details
                          </span>
                        ),
                        children: (
                          <div className="space-y-6">
                            <div>
                              <h4 className="text-white font-semibold mb-2">
                                🚀 What I Built
                              </h4>

                              <ul className="space-y-2">
                                {project.learnings.map((item) => (
                                  <li
                                    key={item}
                                    className="text-gray-400 text-sm flex gap-2"
                                  >
                                    <span className="text-yellow-400">•</span>
                                    {item}
                                  </li>
                                ))}
                              </ul>
                            </div>

                            <div>
                              <h4 className="text-white font-semibold mb-2">
                                ⚡ Challenges
                              </h4>

                              <ul className="space-y-2">
                                {project.challenges.map((item) => (
                                  <li
                                    key={item}
                                    className="text-gray-400 text-sm flex gap-2"
                                  >
                                    <span className="text-red-400">•</span>
                                    {item}
                                  </li>
                                ))}
                              </ul>
                            </div>

                            {/* <a
                              href={project.link}
                              target="_blank"
                              rel="noreferrer"
                              className="inline-flex items-center gap-2 rounded-xl bg-yellow-400 px-5 py-3 font-semibold text-black hover:scale-105 transition"
                            >
                              Visit Project
                              <RiExternalLinkFill />
                            </a> */}
                          </div>
                        ),
                      },
                    ]}
                  />
                </div>

                {/* <div className="mt-8 flex items-center justify-between">
                  <button
                    onClick={() => navigate(`/case-study/${project.title}`)}
                    className="flex items-center gap-2 font-medium text-yellow-400 transition hover:gap-3"
                  >
                    View Case Study
                    <NavigateNextOutlinedIcon fontSize="small" />
                  </button>

                  <a
                    href={project.link}
                    target="_blank"
                    rel="noreferrer"
                    className="flex items-center gap-2 rounded-xl border border-white/10 bg-white/5 px-4 py-2 text-sm text-white transition hover:border-yellow-400/40 hover:bg-white/10"
                  >
                    Visit
                    <RiExternalLinkFill size={15} />
                  </a>
                </div> */}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
